export default class LocalStorage {
    setUser(user) {
        localStorage.setItem('user', JSON.stringify(user));
    }

    removeUser() {
        localStorage.removeItem('user');
    }

    getTokenId() {
        return localStorage.getItem('token_id');
    }

    removeTokenId() {
        localStorage.removeItem('token_id');
    }

    setCountry(country) {
        localStorage.setItem('country', country)
    }

    getCountry() {
        return localStorage.getItem('country')
    }

    removeCountry() {
        localStorage.removeItem('country');
    }

    setCountryCode(country_code) {
        localStorage.setItem('country_code', country_code)
    }

    getCountryCode() {
        return localStorage.getItem('country_code')
    }

    removeCountryCode() {
        localStorage.removeItem('country_code');
    }

    getUser() {
        return new Promise(((resolve) => {
            resolve(JSON.parse(localStorage.getItem('user')))
        }))
    }

    setLocation(latLonLikeObj) {
        localStorage.setItem('location', JSON.stringify(latLonLikeObj))
    }

    getLocation() {
        return new Promise(((resolve) => {
            resolve(JSON.parse(localStorage.getItem('location')))
        }))
    }
}
